"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainerNotification = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var asg_1 = require("@alinta-digital/asg");
exports.StyledContainerNotification = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  margin-top: 24px;\n"], ["\n  background-color: ", ";\n  margin-top: 24px;\n"])), asg_1.colors['grey-1']);
var templateObject_1;
//# sourceMappingURL=PaymentMethodCheckBox.styled.js.map